import { useLazyQuery } from '@apollo/client';
import { exportXlsModal } from 'motion-components';
import { gqlGetQuery } from '../graphql';
import { buildWhereFromFilterValues } from './filters';
import { useState } from 'react';
import { format, parseISO } from 'date-fns';

export const exportColumns = (t) => {
  return [
    // { fieldName: "id", fieldTitle: "Id", fieldType: "TEXT" },
    { fieldName: 'id', fieldTitle: 'ID', fieldType: 'TEXT' },
    { fieldName: 'name', fieldTitle: t('Κάδος Αποβλήτων'), fieldType: 'TEXT' },
    { fieldName: 'matIds', fieldTitle: t('Απόβλητα Κάδου'), fieldType: 'TEXT' },
    { fieldName: 'isActive', fieldTitle: t('Ενεργή Εγγραφή'), fieldType: 'TEXT' },
    { fieldName: 'firstRec', fieldTitle: t('Δήλωση'), fieldType: 'TEXT' },
    { fieldName: 'lastRec', fieldTitle: t('Αλλαγή'), fieldType: 'TEXT' },
  ];
};

export async function handleExport(client, queryState: any, t): Promise<void> {
  function useGetQuery() {
    const [get, { loading }] = useLazyQuery(gqlGetQuery, { onCompleted: transformData });
    const [result, setResult] = useState<any>([get, { loading, data: undefined }]);
    function transformData(data) {
      const recs = data.getContainertypes.data.map((values) => {
        const mats = !values.containertypesMaterials
          ? []
          : values.containertypesMaterials
              .filter((v) => v.isActive)
              .map((value) => {
                return { id: value.materialId, name: value.material.name };
              })
              .sort((a, b) => {
                const nameA = a.name.toUpperCase(); // ignore upper and lowercase
                const nameB = b.name.toUpperCase(); // ignore upper and lowercase
                if (nameA < nameB) {
                  return -1;
                }
                if (nameA > nameB) {
                  return 1;
                }
                // names must be equal
                return 0;
              });
        const matNames = mats.map((v) => v.name).join(', ');
        return {
          ...values,
          isActive: !values.isActive ? t('ΟΧΙ') : t('ΝΑΙ'),
          firstRec: ` ${
            values.firstDate ? format(parseISO(values.firstDate), 'dd/MM/yy HH:mm') : ''
          }  - ${values.firstUser}`,
          lastRec: ` ${
            values.lastDate ? format(parseISO(values.lastDate), 'dd/MM/yy HH:mm') : ''
          }  - ${values.lastUser}`,
          matIds: matNames,
        };
      });
      const trsData = {
        getContainertypes: { data: recs, recordCount: data?.getContainertypes?.recordCount },
      };
      setResult([get, { loading, data: trsData }]);
    }
    return result;
  }
  const filterVariables = {
    where: buildWhereFromFilterValues(queryState?.filterValues),
  };
  await exportXlsModal({
    apolloClient: client,
    exportFileName: 'export ContainerTypes',
    getLazyQuery: useGetQuery,
    columnsDef: exportColumns(t),
    filterVariables: filterVariables,
  });
}

